module.exports = __webpack_public_path__ + "img/capa-compra-loading.f0933986.png";